var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _radialGradient, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResultFailure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "0 -5 511.99974 511",
    width: "511pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 146.5179700744,
    x2: 354.910392167,
    y1: 106.9104844298,
    y2: 315.3030069146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecf7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2e0ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#c2e0ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#bfdcfd",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9eb2e7"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 481.1056965876,
    x2: 327.7841185504,
    xlinkHref: "#b",
    y1: 473.4657980124,
    y2: 320.1442199752
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 256.000483,
    x2: 256.000483,
    xlinkHref: "#b",
    y1: 401.6151004724,
    y2: 493.4771760228
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 195.9866281932,
    cy: 182.3610454774,
    gradientUnits: "userSpaceOnUse",
    r: 290.5769907396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2296,
    stopColor: "#ffd355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4362,
    stopColor: "#ffcf4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#ffc838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#ffbf1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb400"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e58200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0396,
    stopColor: "#e27f04",
    stopOpacity: 0.039216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    stopColor: "#c15d2f",
    stopOpacity: 0.466667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    stopColor: "#ad4949",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 383.22751806,
    x2: 100.5138467776,
    xlinkHref: "#f",
    y1: 279.4956189796,
    y2: 190.2705453466
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45425a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d3251"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 232.481602306,
    x2: 278.751865325,
    xlinkHref: "#h",
    y1: 204.3142094202,
    y2: 204.3142094202
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 308.9683112498,
    x2: 209.7275093916,
    xlinkHref: "#f",
    y1: 420.9684076118,
    y2: 321.7276057536
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 221.9693342596,
    x2: 290.0316317404,
    xlinkHref: "#h",
    y1: 368.000579362,
    y2: 368.000579362
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m430.613281 39.335938-85.210937-25.664063c-58.308594-17.5625-120.496094-17.5625-178.800782 0l-85.214843 25.664063c-12.84375 3.867187-23.171875 13.46875-27.96875 25.996093l-40.757813 106.429688c-30.183594 78.820312-5.125 168.105469 61.660156 219.707031l111.429688 86.097656c41.375 31.972656 99.125 31.972656 140.5 0l111.429688-86.097656c66.785156-51.601562 91.84375-140.886719 61.660156-219.707031l-40.753906-106.429688c-4.800782-12.527343-15.128907-22.128906-27.972657-25.996093zm0 0",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m389.386719 119.714844c-33.703125-34.941406-81.003907-56.679688-133.386719-56.679688-102.351562 0-185.324219 82.972656-185.324219 185.324219 0 52.382813 21.738281 99.683594 56.679688 133.390625l119.425781 119.425781c27.785156 2.230469 56.214844-5.640625 79.46875-23.609375l111.429688-86.097656c47.277343-36.53125 73.640624-91.945312 74.300781-149.164062zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m64.21875 383.085938c3.253906 2.890624 6.617188 5.691406 10.101562 8.382812l111.429688 86.097656c41.378906 31.972656 99.125 31.972656 140.5 0l111.429688-86.097656c3.484374-2.691406 6.847656-5.492188 10.105468-8.382812zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m441.324219 248.359375c0 102.351563-82.972657 185.324219-185.324219 185.324219s-185.324219-82.972656-185.324219-185.324219 82.972657-185.324219 185.324219-185.324219 185.324219 82.972656 185.324219 185.324219zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m439.78125 272.359375-164.835938-164.835937c-.421874-.601563-.871093-1.1875-1.363281-1.738282-3.445312-3.847656-8.84375-5.769531-16.199219-5.769531-7.351562 0-13.339843 1.847656-17.964843 5.542969-4.625 3.699218-6.9375 8.949218-6.9375 15.742187 0 21.292969.875 56.03125 2.621093 104.226563 1.746094 48.195312 2.621094 47.609375 2.621094 68.894531 0 5.152344 1.957032 8.890625 5.839844 11.234375l103.910156 103.910156c49.445313-28.121094 84.695313-78.328125 92.308594-137.207031zm0 0",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m232.480469 121.300781c0-6.792969 2.3125-12.046875 6.9375-15.742187 4.625-3.695313 10.613281-5.546875 17.964843-5.546875 7.355469 0 12.757813 1.921875 16.199219 5.769531 3.445313 3.847656 5.171875 9.019531 5.171875 15.519531 0 21.292969-.371094 56.03125-1.089844 104.222657-.730468 48.195312-1.09375 47.609374-1.09375 68.898437 0 4.4375-2.078124 7.917969-6.234374 10.425781-4.160157 2.511719-8.476563 3.765625-12.953126 3.765625-13.105468 0-19.660156-4.726562-19.660156-14.191406 0-21.289063-.875-20.703125-2.621094-68.898437-1.746093-48.191407-2.621093-82.929688-2.621093-104.222657zm0 0",
    fill: "url(#i)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m346.210938 410.269531-64.179688-64.179687c-6.242188-7.410156-15.585938-12.121094-26.03125-12.121094-18.792969 0-34.03125 15.238281-34.03125 34.03125 0 10.445312 4.714844 19.789062 12.121094 26.03125l38.871094 38.875c26.410156-2.398438 51.214843-10.332031 73.25-22.636719zm0 0",
    fill: "url(#j)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m290.03125 368c0 18.796875-15.234375 34.03125-34.03125 34.03125-18.792969 0-34.03125-15.234375-34.03125-34.03125 0-18.792969 15.238281-34.03125 34.03125-34.03125 18.796875 0 34.03125 15.238281 34.03125 34.03125zm0 0",
    fill: "url(#k)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultFailure);
export default __webpack_public_path__ + "static/media/result-failure.b2e1131a1a3bac441682c921caa6ba9f.svg";
export { ForwardRef as ReactComponent };